<template>
  <el-dialog :visible.sync="visible" width="1200px" title="充电记录地图" :close-on-click-modal="false"
    custom-class="charging-record-map-dialog" @opened="initMap" @closed="clearMap">
    <div id="chargingRecordMap" class="map-container"></div>
  </el-dialog>
</template>

<script>
import { DateUtil } from "@/util";

const carRedPng = require("@/assets/image/car_red.png");

export default {
  name: "ChargingRecordMapModal",
  data() {
    return {
      visible: false,
      list: [],
      map: null,
      markers: []
    };
  },
  methods: {
    open(chargingRecordList = []) {
      this.list = chargingRecordList || [];
      this.visible = true;
    },
    initMap() {
      if (!document.getElementById("chargingRecordMap")) return;
      this.map = new AMap.Map("chargingRecordMap", {
        resizeEnable: true,
        dragEnable: true,
        zoom: 12
      });
      this.$nextTick(() => {
        this.addMarkers();
      });
    },
    addMarkers() {
      if (!this.map || !this.list.length) return;
      const recordsWithPosition = this.list.filter((record) => {
        const pos = this.getRecordPosition(record);
        return pos && pos.lat && pos.lng;
      });
      if (!recordsWithPosition.length) return;
      this.markers = [];
      recordsWithPosition.forEach((record) => {
        const position = this.getRecordPosition(record);
        const lng = parseFloat(position.lng);
        const lat = parseFloat(position.lat);
        const name = position.name || "充电位置";
        const timeStr = record.startTime
          ? DateUtil.dateStrFormat(record.startTime, "MM-dd hh:mm") +
          (record.endTime ? " ~ " + DateUtil.dateStrFormat(record.endTime, "hh:mm") : "")
          : "—";
        const capacityStr =
          record.chargingCapacity !== undefined && record.chargingCapacity !== null
            ? record.chargingCapacity + "%"
            : record.startSoc != null && record.endSoc != null
              ? record.startSoc + "% ~ " + record.endSoc + "%"
              : "—";
        const marker = new AMap.Marker({
          position: [lng, lat],
          anchor: "bottom-center",
          label: {
            direction: "top",
            content: `<div class='info'>${name}<br/>充电时间：${timeStr}<br/>充电电量：${capacityStr}</div>`
          },
          draggable: true,
          icon: new AMap.Icon({
            size: new AMap.Size(40, 40),
            image: carRedPng,
            imageSize: new AMap.Size(40, 40)
          })
        });
        this.map.add(marker);
        this.markers.push(marker);
      });
      if (this.markers.length > 0) {
        this.map.setFitView(this.markers);
      }
    },
    getRecordPosition(record) {
      if (record.endChargePosition && record.endChargePosition.lat && record.endChargePosition.lng) {
        return record.endChargePosition;
      }
      if (record.startChargePosition && record.startChargePosition.lat && record.startChargePosition.lng) {
        return record.startChargePosition;
      }
      return null;
    },
    clearMap() {
      this.list = [];
      this.markers = [];
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.map-container {
  width: 100%;
  height: 560px;
}
</style>

<style lang="less">
.charging-record-map-dialog .el-dialog__body {
  padding: 20px;
}
</style>
